//                                              [IMPORTS]
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import "./Admin2.css";

import FinansijeKlijenti from "./finansije/Finansijeklijenti";
import FinansijeSajtovi from "./finansije/Finansijesajtovi";
import Pretplate from "./finansije/Pretplate";


export default function Finansije() {

  const navigate = useNavigate();

  //active tabs


    const [activeTab, setActiveTab] = useState("users");
    const [sidebarOpen, setSidebarOpen] = useState(false);


 //                                                          MEHANIZAM ZA PROVERU TOKENA I ULOGE KORISNIKA


  useEffect(() => {
    const token = localStorage.getItem("token");
    // ako nema JWT → nema ulaza
    if (!token) {
      navigate("/login");
    }
        try {
        const decoded = jwtDecode(token);
        // Proveravamo ulogu iz tokena
        if (!decoded.role || decoded.role !== "finansije") {
        navigate("/roleredirect"); // ako nije admin → Error stranica
        }
        } catch (err) {
          // token ne može da se dekodira
          navigate("/error");
        }
  }, [navigate]);




  return (

    <div className="min-vh-100 bg-dark text-white">
      <nav className="navbar navbar-dark bg-black px-4">
          <span className="navbar-brand fw-bold">
            <span className="text-primary">Alpha</span>PremiumSolutions Finansije i Racunovodstvo
          </span>
          <button className="hamburger d-lg-none" onClick={() => setSidebarOpen(true)}>☰</button>
          <button className="btn btn-outline-danger btn-sm" 
          onClick={() => { 
            localStorage.removeItem("token"); 
            navigate("/login");
          }}> Logout </button>
      </nav>

      {/* NAVBAR ZA STAVKE */}
      <div className="admin-layout">
      
      {/* SIDEBAR */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>

        <h5 className="sidebar-title">Dashboard</h5>

        {/* USERS */}
        <div className="sidebar-section">
          <p className="section-title">Users</p>
          <button onClick={() => setActiveTab("users")}>View</button>
        </div>

        {/* WEBSITES */}
        <div className="sidebar-section">
          <p className="section-title">Websites</p>
          <button onClick={() => setActiveTab("websites")}>View</button>
        </div>

        {/* Racunovodstvo */}
        <div className="sidebar-section">
          <p className="section-title">Racunovodstvo</p>
          <button onClick={() => setActiveTab("pretplate")}>Pretplate</button>
        </div>

        <hr />

        <button className="settings-btn" onClick={() => setActiveTab("settings")}>
          Settings
        </button>

      </aside>

      {sidebarOpen && ( <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} /> )}

      {/* CONTENT */}
      <main className="admin-content">

        {activeTab === "users" && <FinansijeKlijenti />}

        {activeTab === "websites" && <FinansijeSajtovi />}
        {activeTab === "pretplate" && <Pretplate />}
    </main>

       </div>
    </div>
  );

}
